module.exports = __webpack_public_path__ + "static/media/expand-more-icon2.d022480b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/expand-more-icon2.svg
// module id = 739
// module chunks = 0